import ActionCreator from "../../utils/redux/ActionCreator";
import { getQuiz, getAllQuiz, addOrUpdate, deleteQuiz } from "core/database/quiz";

const { actions, defaultReducer, get, getSimple, add, remove, update, set } = new ActionCreator("quiz");
export { actions, defaultReducer };


export const getQuizByIdData = getSimple(getQuiz);
export const getAllQuizData = get(getAllQuiz);
export const getQuizData = get(getQuiz);
export const addQuizData = add(addOrUpdate);
export const updateQuizData = update(addOrUpdate);
export const deleteQuizData = remove(deleteQuiz);
export const setQuizDateRange = set('QUIZ-LIST-DATE-RANGE');